import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Button, IconGoogle } from "../../../components/atoms"
import { InputGroup, SelectGroup } from "../../../components/molecules"
import { Pagination } from "../../../components/organisms"
import {
  RowContract,
  TablePartner
} from "../../../components/organisms/TablePartner"
import { api } from "../../../helpers"

export function Partners() {
  const navigate = useNavigate()
  const [paginationControl, setPaginationControl] = useState<PaginationType>({
    offset: 0,
    limit: 5,
    count: 0
  })

  const [Parceiros, setParceiros] = useState<RowContract[]>([])

  const [filtro, setFiltro] = useState("p.nome")
  const [procurar, setProcurar] = useState("")
  const [ordenar, setOrdenar] = useState("p.nome")
  const [procurarErrorMessage, setProcurarErrorMessage] =
    useState<boolean>(false)

  useEffect(() => {
    if (procurar) consultar()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationControl.limit, paginationControl.offset])

  const consultar = async () => {
    const {
      data: { TotalRegistros, Registros }
    } = await api.post("/api/clientes/search", {
      vempresa: "7",
      vcampo: filtro,
      vvalor: procurar,
      vordena: ordenar,
      limit: paginationControl.limit,
      offset: paginationControl.offset
    })

    setParceiros([])
    if (TotalRegistros > 0) {
      const convertingDataToDisplay = (registros: any) =>
        registros.map((registro: any) => {
          return {
            ...registro
          }
        })

      setPaginationControl((current) => ({
        ...current,
        count: TotalRegistros
      }))
      const convertedDataForDisplay = convertingDataToDisplay(Registros)
      setParceiros(convertedDataForDisplay)
    }
  }

  return (
    <div>
      <h2>Parceiros</h2>
      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            //            className="col-xl-2 col-lg-3 col-md-3 col-sm-12"
            value={String(paginationControl.limit)}
            id="resultsPerPage"
            label="Resultados por pág"
            options={[
              { text: "5", value: 5 },
              { text: "10", value: 10 },
              { text: "25", value: 25 },
              { text: "50", value: 50 }
            ]}
            onChange={(e) => {
              setPaginationControl({
                ...paginationControl,
                limit: Number(e.target.value !== "0" ? e.target.value : "5"),
                offset: 0
              })
            }}
          />
        </div>

        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            //            className="col-xl-2 col-lg-3 col-md-3 col-sm-12"
            value={filtro}
            id="filtro"
            label="Filtrar por"
            options={[
              { text: "Codigo", value: "p.codigo" },
              { text: "Nome", value: "p.nome" },
              { text: "CPF", value: "p.CPF" },
              { text: "Telefone", value: "p.Telefone" }
            ]}
            onChange={(e) => {
              setFiltro(e.target.value)
            }}
          />
        </div>

        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-2"
            label="Procurar por"
            messageError={procurarErrorMessage ? "Campo obrigatório!" : ""}
            id="procurar"
            type="string"
            value={procurar}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setProcurarErrorMessage(true)
              else {
                setProcurar(e.target.value)
                setProcurarErrorMessage(false)
              }
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                consultar()
              }
            }}
          />
        </div>

        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            //            className="col-xl-2 col-lg-3 col-md-3 col-sm-12"
            value={ordenar}
            id="ordenar"
            label="Ordenar por"
            options={[
              { text: "Codigo", value: "p.codigo" },
              { text: "Nome", value: "p.nome" },
              { text: "CPF", value: "p.CPF" },
              { text: "Telefone", value: "p.Telefone" }
            ]}
            onChange={(e) => {
              setOrdenar(e.target.value)
            }}
          />
        </div>

        <div className="row mt-3"></div>

        <div className="col-sm-12 col-lg-2">
          <Button
            appearance="success"
            onClick={() => {
              navigate("/cadastros/parceiros/new")
            }}
          >
            Novo<IconGoogle>add</IconGoogle>
          </Button>
        </div>
        <div className="col-sm-12 col-lg-4"></div>
        <div className="col-sm-12 col-lg-4"></div>
        <div className="col-sm-12 col-lg-2">
          <Button
            appearance="success"
            onClick={() => {
              consultar()
            }}
          >
            Consultar<IconGoogle>manage_search</IconGoogle>
          </Button>
        </div>

        <TablePartner
          data={Parceiros}
          onClick={(data) => setParceiros(data)}
        ></TablePartner>

        <Pagination
          className="col-12"
          data={paginationControl}
          dispatch={setPaginationControl}
        />
      </div>
    </div>
  )
}
